const GADS_ID = "AW-18441432775";

const CONVERSION_LABELS = {
  booking: "",
};

export const trackConversion = (action = "booking") => {
  if (typeof window.gtag !== "function") return;
  const label = CONVERSION_LABELS[action];
  window.gtag("event", "conversion", {
    send_to: label ? `${GADS_ID}/${label}` : GADS_ID,
  });
};
